import styles from "./styles.module.scss";

interface IText {
	text: string;
}

const TextView: React.FunctionComponent<IText> = ({ text }) => {
	return <div className={styles.container}>{text}</div>;
};
export default TextView;
